<template>
  <div class="customer-satisfaction-percentage">
    <p class="customer-satisfaction-percentage_title">Percentage of Satisfaction</p>
    <NoResultsFound v-if="isNoResult" class="customer-satisfaction-percentage_no-result" />
    <div v-else class="customer-satisfaction-percentage_content">
      <p class="customer-satisfaction-percentage_value">{{ surveyedStat.percentage_of_satisfied }}%</p>
      <div class="satisfied-container-wrapper">
        <div class="satisfied-container">
          <i class="bx bx-smile very-satisfied-icon" />
          <p class="count-value">{{ surveyedStat.very_satisfied }}</p>
          <p class="count-label">very satisfied</p>
        </div>
        <div class="satisfied-container">
          <i class="bx bx-smile satisfied-icon" />
          <p class="count-value">{{ surveyedStat.satisfied }}</p>
          <p class="count-label">satisfied</p>
        </div>
      </div>
      <div class="respondents">
        <p>From</p>
        <i class="bx bx-group" />
        <p>{{ respondents }} Respondents</p>
      </div>
    </div>
  </div>
</template>
<script>
import NoResultsFound from '../NoResultsFound.vue';

export default {
  name: 'CustomerSatisfactionPercentageWidget',
  props: {
    surveyedStat: {
      type: Object,
      default: () => ({}),
    },
    respondents: {
      type: Number,
      default: 0,
    },
  },
  components: {
    NoResultsFound,
  },
  computed: {
    isNoResult() {
      if (this.surveyedStat.percentage_of_satisfied <= 0 || this.respondents <= 0) {
        return true;
      }

      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
.customer-satisfaction-percentage {
  display: flex;
  flex-direction: column;
  align-items: center;
  p {
    margin: 0;
    line-height: 150%;
  }
  i {
    font-size: 20px;
  }
  .customer-satisfaction-percentage_no-result {
    padding-top: 40px;
  }
  .customer-satisfaction-percentage_title {
    font-weight: 600;
    font-size: 16px;
    line-height: 140%;
    color: #4b5178;
  }
  .customer-satisfaction-percentage_content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .customer-satisfaction-percentage_value {
    font-weight: 500;
    font-size: 40px;
    line-height: 120%;
    color: #111b49;
    padding-top: 20px;
  }
  .satisfied-container-wrapper {
    display: flex;
    gap: 16px;
    padding-top: 20px;
    .satisfied-container {
      display: flex;
      align-items: center;
      gap: 8px;
      .very-satisfied-icon {
        color: #36bc9b;
        background-color: #def7ef;
        border-radius: 50%;
      }
      .satisfied-icon {
        color: #a0d467;
        background-color: #ecf7de;
        border-radius: 50%;
      }
      .count-value {
        font-weight: 600;
        font-size: 14px;
        color: #4b5178;
      }
      .count-label {
        font-weight: 400;
        font-size: 14px;
        color: #4b5178;
      }
    }
  }
  .respondents {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding-top: 4px;
    i {
      color: #59cbe8;
    }
    p {
      font-weight: 400;
      font-size: 12px;
      color: #646a8c;
    }
  }
}
</style>
